import React from 'react'
import { CheckCircle, AlertCircle, MessageSquare, Calendar } from 'lucide-react'

export interface PriorityBarProps {
  needsVerification: number
  overdue: number
  kidRequests: number
  todayEvents: number
  onSectionClick: (section: 'verify' | 'overdue' | 'requests' | 'events') => void
}

export const PriorityBar: React.FC<PriorityBarProps> = ({
  needsVerification,
  overdue,
  kidRequests,
  todayEvents,
  onSectionClick
}) => {
  const hasAlerts = needsVerification > 0 || overdue > 0 || kidRequests > 0 || todayEvents > 0

  if (!hasAlerts) {
    return null
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {needsVerification > 0 && (
          <button
            onClick={() => onSectionClick('verify')}
            className="flex items-center gap-3 p-3 rounded-lg bg-yellow-50 hover:bg-yellow-100 border border-yellow-200 transition-colors text-left"
          >
            <CheckCircle className="w-5 h-5 text-yellow-600 flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-sm font-medium text-gray-700">Needs Verification</div>
              <div className="text-2xl font-bold text-yellow-600">{needsVerification}</div>
            </div>
          </button>
        )}

        {overdue > 0 && (
          <button
            onClick={() => onSectionClick('overdue')}
            className="flex items-center gap-3 p-3 rounded-lg bg-red-50 hover:bg-red-100 border border-red-200 transition-colors text-left"
          >
            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-sm font-medium text-gray-700">Overdue</div>
              <div className="text-2xl font-bold text-red-600">{overdue}</div>
            </div>
          </button>
        )}

        {kidRequests > 0 && (
          <button
            onClick={() => onSectionClick('requests')}
            className="flex items-center gap-3 p-3 rounded-lg bg-blue-50 hover:bg-blue-100 border border-blue-200 transition-colors text-left"
          >
            <MessageSquare className="w-5 h-5 text-blue-600 flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-sm font-medium text-gray-700">Kid Requests</div>
              <div className="text-2xl font-bold text-blue-600">{kidRequests}</div>
            </div>
          </button>
        )}

        {todayEvents > 0 && (
          <button
            onClick={() => onSectionClick('events')}
            className="flex items-center gap-3 p-3 rounded-lg bg-purple-50 hover:bg-purple-100 border border-purple-200 transition-colors text-left"
          >
            <Calendar className="w-5 h-5 text-purple-600 flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-sm font-medium text-gray-700">Today's Events</div>
              <div className="text-2xl font-bold text-purple-600">{todayEvents}</div>
            </div>
          </button>
        )}
      </div>
    </div>
  )
}
